"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _calendar = require("@kyruus/calendar");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const id = 'jumpToDateCalendar';
const BaseDatePicker = _ref => {
  let {
    date,
    onDateChange,
    onClose,
    intl
  } = _ref;
  const [calendarFocused, setCalendarFocused] = (0, _react.useState)(false);
  const handleDateChange = date => {
    // if the date entered is not a valid date, date will be null
    if (date == null) return;
    onDateChange(date);
  };
  const handleEscape = event => {
    if (event.key === 'Escape') setCalendarFocused(false);
    if (onClose) onClose(event);
  };
  (0, _react.useEffect)(() => {
    // Event doesn't propagate from the SingleDatePicker
    // and SingleDatePicker doesn't support passing in a
    // key handler. Attach the event directly instead.
    document.querySelector(`#${id}`)?.addEventListener('keydown', handleEscape);
    return () => {
      document.querySelector(`#${id}`)?.removeEventListener('keydown', handleEscape);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_styles.DatePicker, {
    "aria-label": intl.formatMessage(_messages.default.ariaJumpToDateCalendarButton),
    "data-testid": "jumpToDateCalendarContainer",
    className: date ? 'active' : null,
    onKeyDown: handleEscape
  }, /*#__PURE__*/_react.default.createElement(_calendar.SingleDatePicker, {
    ariaLabel: intl.formatMessage(_messages.default.ariaJumpToDateCalendarInput),
    date: date && (0, _moment.default)(date) || null,
    focused: calendarFocused,
    hideKeyboardShortcutsPanel: true,
    id: id,
    inputIconPosition: "after",
    numberOfMonths: 1,
    onDateChange: handleDateChange,
    onFocusChange: _ref2 => {
      let {
        focused
      } = _ref2;
      return setCalendarFocused(focused);
    },
    placeholder: intl.formatMessage(_messages.default.apptTimeCalendarPlaceholder),
    screenReaderInputMessage: intl.formatMessage(_messages.default.ariaJumpToDateInputDescription),
    showDefaultInputIcon: true,
    small: true,
    readOnly: true
  }));
};
BaseDatePicker.defaultProps = {
  date: null
};
BaseDatePicker.propTypes = {
  date: _propTypes.string,
  onDateChange: _propTypes.func.isRequired,
  onClose: _propTypes.func,
  intl: (0, _propTypes.shape)({
    formatMessage: _propTypes.func.isRequired
  })
};
var _default = exports.default = (0, _intl.injectIntl)(BaseDatePicker);
BaseDatePicker.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BaseDatePicker",
  "props": {
    "date": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onDateChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onClose": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": false
    }
  }
};